var React = require('react');

function DismissCall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.16589 7.43862L5.13632 7.43862C6.19719 7.43862 6.88673 6.32469 6.40936 5.42297C6.09108 4.78643 6.3563 3.99078 6.9398 3.6195C8.26588 2.82385 11.0772 2.7708 12.4563 3.6195C13.0929 3.93778 13.305 4.78647 12.9867 5.42297C12.5094 6.32471 13.1989 7.43862 14.2598 7.43862L17.2302 7.43862C18.0259 7.38558 18.6624 6.74906 18.6624 6.00645V3.9908C18.6093 1.92211 14.6841 0.224719 9.69806 0.224719C4.71198 0.224719 0.733698 1.86904 0.73372 3.9908L0.733719 6.00645C0.786742 6.80212 1.42326 7.43864 2.16589 7.43862Z","fill":"white"}));
}

DismissCall.defaultProps = {"width":"19","height":"8","viewBox":"0 0 19 8","fill":"none"};

module.exports = DismissCall;

DismissCall.default = DismissCall;
